import script from "./Triangle.vue?vue&type=script&setup=true&lang=ts"
export * from "./Triangle.vue?vue&type=script&setup=true&lang=ts"

import "./Triangle.vue?vue&type=style&index=0&id=9d9c8490&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d9c8490"]])

export default __exports__